// Form Names
export const aboutYouFormIdentifier = 'aboutYou';
export const yourCarFormIdentifier = 'yourCar';
export const yourHomeFormIdentifier = 'yourHome';
export const yourCoverFormIdentifier = 'yourCover';
export const yourCarCoverFormIdentifier = 'yourCarCover';
export const yourTravelFormIdentifier = 'yourTravel';
export const yourTravelCoverFormIdentifier = 'yourTravelCover';

